// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mm-1";
export var spinner = "_mm-0";